import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createStore, compose } from 'redux';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import initialState, { STATE_KEYS_NEED_TO_BE_PERSISTED } from './initvalues';
import session, { STATE } from './session';
import { getQueryParam, isPreviewMode } from '../utils/tool';

if (!isPreviewMode()) {
  // eslint-disable-next-line
  const {
    timestamp,
    state = {}
  } = session.get(STATE) || {};
  const {
    promotionId: preOromotionId
  } = state;
  const {
    promotionId
  } = getQueryParam();

  if (state && preOromotionId === promotionId) {
    // TODO: 考虑过期检查
    Object.assign(initialState, state);
  } else {
    initialState.promotionId = promotionId;
  }
}

export const formPrefix = 'formValues';

function reducer(state = initialState, {
  type,
  payload
}) {
  const newState = _objectSpread({}, state);

  if (!payload) {
    return newState;
  }

  switch (type) {
    case 'configJson':
      Object.keys(payload).forEach(key => {
        _.set(newState, key, payload[key]);
      });
      return newState;

    case 'setPageNum':
      Object.keys(payload).forEach(key => {
        _.set(newState, key, payload[key]);
      });
      return newState;

    case 'setFormValue':
      Object.keys(payload).forEach(key => {
        _.set(newState, `${formPrefix}.${key}`, payload[key]);
      });
      return newState;

    case 'set':
      Object.keys(payload).forEach(key => {
        _.set(newState, key, payload[key]);
      });
      return newState;

    default:
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(reducer,
/* preloadedState, */
composeEnhancers()); // 数据变时同步sessionstoreage

store.subscribe(_.debounce(() => {
  const dataToPersist = _.pick(store.getState(), STATE_KEYS_NEED_TO_BE_PERSISTED);

  session.set(STATE, {
    timestamp: Date.now(),
    state: dataToPersist
  });
}), 300);
/**
 * @Author: wangshengqiang
 * @LastEditors: wangshengqiang
 * @param {*} path 根据字段路径从store中获取值
 */

export function getState(path) {
  const state = store.getState();
  return path ? _.get(state, path) : state;
}
/**
 * 监听某路径下值的变化，适合值类型或者引用发生变化的引用类型 (弃)
 */

export function subscribe(callback, path) {
  let oldState = getState(path);
  return store.subscribe(_.debounce(() => {
    const newState = getState(path);

    if (newState !== oldState) {
      oldState = newState; // console.log('index.js:54', newState, store);

      callback(newState, store);
    }
  }, 300));
}
/**
 * @Author: wangshengqiang
 * @LastEditors: wangshengqiang
 * @param {*} payload string 字段路径 | {} 每个属性key值会作为字段路径
 * @param {*} value 只有当payload 为string类型有用
 */

export function dispatch(payload, value) {
  if (typeof payload === 'string') {
    payload = {
      [payload]: value
    };
  }

  return store.dispatch({
    type: 'set',
    payload
  });
}
/**
 * @Author: wangshengqiang
 * @LastEditors: wangshengqiang
 * @param {*} statePath 根据字段路径从store中获取值 带有监听功能
 */

export const useStore = statePath => {
  const value = useSelector(state => {
    return _.get(state, statePath);
  });
  return value;
}; // 对表单提供快捷操作的方法

export function setFormValue(payload, value) {
  if (payload) {
    if (typeof payload === 'string') {
      payload = {
        [payload]: value
      };
    }

    store.dispatch({
      type: 'setFormValue',
      payload
    });
  }
}
export function getFormValue(prop, defaultValue) {
  if (prop) {
    const value = getState(`${formPrefix}.${prop}`);
    return value === undefined ? defaultValue : value;
  }
}
export function getPropPath(current, target) {
  if (target && /\./.test(current)) {
    return current.replace(/\.[^.]+$/, `.${target}`);
  }

  return target;
}
/**
 * 监听某路径下整个树形结构的变化，适合所有类型，开销比subscribe大
 */

export function subscribeTree(callback, path) {
  let oldState = JSON.stringify(getState(path));
  return store.subscribe(_.debounce(() => {
    const newState = JSON.stringify(getState(path));

    if (newState !== oldState) {
      oldState = newState;
      callback(JSON.parse(newState), store);
    }
  }, 300));
}
export function subscribeChange(callback, path, flag) {
  if (path && callback) {
    if (flag) {
      return subscribeTree(callback, `${formPrefix}.${path}`);
    }

    return subscribe(callback, `${formPrefix}.${path}`);
  }
}
window.store = store;